export default "<p>admin-user-students works!</p>\n"